var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"page-container"},[_vm._v("403 No permissions")])}
var staticRenderFns = []

export { render, staticRenderFns }